(ns hai.interfaces.slack.routes
  (:require [hai.ui.components :as c]
            [hai.web-app.layout :as layout]))

(defn interfaces-slack-page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Your Humble in Slack"]]
   [:div [:a {:href "https://www.thehumbleai.com/welcome-humble-assistant-in-slack"
              :target "_blank"} "https://www.thehumbleai.com/welcome-humble-assistant-in-slack"]]])

